module.exports = __webpack_public_path__ + "img/regtime_logo_inv.7301c83e.svg";